import ActionType from 'actions/ActionType'

export default (state = 'new', action) => {
  switch (action.type) {
    case ActionType.Campaign.RECEIVE_CAMPAIGN:
      return action.payload === null || typeof action.payload === 'undefined'
        ? 'new'
        : action.payload.id
    case ActionType.Data.CREATE_SUCCESS:
      if (action.entityType === 'campaign') {
        return action.payload.id
      }
      return state
    default:
      return state
  }
}
